import { httpsCallable } from 'firebase/functions';
import { functions, getFunctionsForRegion } from '@/configs/firebase.config';
import { functionNameForRegion, regionalFunctionName } from '@/lib/region';
import * as Sentry from '@sentry/react';

/**
 * @param {{ region?: object }} [options] `region` (from lib/region.js) calls that region's deployment instead of
 *   the page's; only OTP uses it. Without it the call goes to the page's region, as before.
 */
export const callCloudFunction = async (functionName, data, locale = 'en', { region } = {}) => {
    try {
        // Deployed name for the selected country's region (e.g. api-uk-store-nearByStore); throws if none selected.
        const callableFunction = region
            ? httpsCallable(getFunctionsForRegion(region), functionNameForRegion(functionName, region))
            : httpsCallable(functions, regionalFunctionName(functionName));
        const request = interceptRequest(data, locale);
        const result = await callableFunction(request);
        return result.data;
    } catch (error) {
        Sentry.captureException(error, { tags: { feature: 'cloud-function-call' } });
        console.error(`Error calling cloud function ${functionName}`, error);
        throw error;
    }
};

const interceptRequest = (data, locale) => {
    const request = {};
    const language = locale;
    const headers = {
        'Accept-Language': language,
    };
    request.body = data;
    request.headers = headers;
    return request;
};
